module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLAAAAJ2AQMAAAB1jukfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURf///6fEG8gAAABzSURBVBgZ7cEBDQAAAMIg+6d+DjdgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3AnOpAAEeECfMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ending/ending-white.png
// module id = 141
// module chunks = 0